(function () {
    'use strict';

    angular.module("imApp").factory("bulkMailMenuService", [function () {
        let service = {};

        return service;
    }]);
})();
